import { Navigate, Outlet, useLocation, useSearchParams } from "react-router-dom";
import { useAuth } from "@/auth/auth-provider";

export function ProtectedRoute() {
	const { isAuthenticated } = useAuth();
	const location = useLocation();
	if (!isAuthenticated) {
		const next =
			location.pathname === "/"
				? ""
				: `?next=${encodeURIComponent(location.pathname + location.search)}`;
		return <Navigate to={`/login${next}`} replace />;
	}
	return <Outlet />;
}

export function PublicRoute() {
	const { isAuthenticated } = useAuth();
	const [params] = useSearchParams();
	if (isAuthenticated) {
		const next = params.get("next");
		return <Navigate to={next?.startsWith("/") && !next.startsWith("//") ? next : "/"} replace />;
	}
	return <Outlet />;
}
